import { render, staticRenderFns } from "./MessageWithEmojie.vue?vue&type=template&id=78b495ec&"
import script from "./MessageWithEmojie.vue?vue&type=script&lang=js&"
export * from "./MessageWithEmojie.vue?vue&type=script&lang=js&"
import style0 from "./MessageWithEmojie.vue?vue&type=style&index=0&id=78b495ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports